
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/preview",
      function () {
        return require("private-next-pages/blog/preview/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/preview"])
      });
    }
  